{
  "familyId": "TGL-TIJD-SAMENGESTELD",
  "questions": [
    {
      "id": "TGL-TIJD-SAMENGESTELD-001",
      "familyId": "TGL-TIJD-SAMENGESTELD",
      "module": "TijdGeld",
      "tier": 7,
      "levelCode": "M6",
      "group": 6,
      "skill": "tijdrekenen",
      "subSkill": "tijd_samengesteld",
      "questionType": "multiple_choice",
      "question": "Hoeveel minuten zijn 2 uur en 15 minuten samen?",
      "context": null,
      "options": ["135 minuten", "215 minuten", "120 minuten", "75 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_hours_minutes_to_minutes",
      "variantIndex": 1,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "stimulusAids": [],
      "supportAids": [],
      "feedback": {
        "explanationText": "Stap 1: Reken de uren om naar minuten. 1 uur = 60 minuten, dus 2 uur = 2 × 60 = 120 minuten. Stap 2: Tel de losse minuten erbij op. 120 + 15 = 135 minuten. Antwoord: 2 uur en 15 minuten = 135 minuten.",
        "distractorExplanations": {
          "0": "Goed! 2 × 60 = 120 minuten, plus 15 = 135 minuten.",
          "1": "215 minuten klopt niet. Je hebt de getallen 2, 1 en 5 achter elkaar gezet in plaats van te rekenen. Reken altijd stap voor stap: 2 uur = 120 minuten, dan + 15 = 135.",
          "2": "120 minuten is alleen de 2 uur. Je bent de 15 losse minuten vergeten op te tellen: 120 + 15 = 135 minuten.",
          "3": "75 minuten klopt niet. Je hebt waarschijnlijk 60 + 15 = 75 gedaan (1 uur + 15 minuten). Maar het gaat om 2 uur: 2 × 60 = 120, dan + 15 = 135."
        }
      }
    },
    {
      "id": "TGL-TIJD-SAMENGESTELD-002",
      "familyId": "TGL-TIJD-SAMENGESTELD",
      "module": "TijdGeld",
      "tier": 8,
      "levelCode": "E6",
      "group": 6,
      "skill": "tijdrekenen",
      "subSkill": "tijd_samengesteld",
      "questionType": "multiple_choice",
      "question": "Een film duurt 1 uur en 45 minuten. De film begint om 14:30. Hoe laat is de film afgelopen?",
      "context": null,
      "options": ["16:15", "15:75", "16:45", "15:15"],
      "correctAnswer": 0,
      "conceptId": "time_end_time_calculation",
      "variantIndex": 2,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.74,
      "stimulusAids": [],
      "supportAids": [],
      "feedback": {
        "explanationText": "Stap 1: Tel de minuten op. 30 + 45 = 75 minuten. Dat is meer dan 60, dus er zit een extra uur in. Stap 2: 75 minuten = 1 uur en 15 minuten. Stap 3: Tel de uren op. 14 + 1 (film) + 1 (extra uur) = 16 uur. Stap 4: De resterende minuten zijn 15. Antwoord: 16:15.",
        "distractorExplanations": {
          "0": "Goed! 14:30 + 1 uur = 15:30, dan + 45 minuten = 16:15.",
          "1": "15:75 bestaat niet als kloktijd. Je hebt 30 + 45 = 75 minuten opgeteld maar vergeten dat 75 minuten = 1 uur en 15 minuten is. Zet 75 minuten om: 75 − 60 = 15 minuten over, plus 1 extra uur → 16:15.",
          "2": "16:45 klopt niet. Je hebt waarschijnlijk 14 + 1 = 15 uur en dan 30 + 45 = 75 minuten als 45 minuten genomen. Vergeet niet dat 30 + 45 = 75 minuten = 1 uur en 15 minuten, dus het uur wordt 16 en de minuten worden 15.",
          "3": "15:15 klopt niet. Je hebt de uren correct opgeteld (14 + 1 = 15) maar de minuten fout: 30 + 45 = 75, niet 15. Zet 75 minuten om naar 1 uur en 15 minuten, zodat het totaal 16:15 wordt."
        }
      }
    },
    {
      "id": "TGL-TIJD-SAMENGESTELD-003",
      "familyId": "TGL-TIJD-SAMENGESTELD",
      "module": "TijdGeld",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_samengesteld",
      "questionType": "multiple_choice",
      "question": "Een trein vertrekt om 09:45 en komt aan om 12:20. Hoe lang duurt de reis?",
      "context": null,
      "options": ["2 uur en 35 minuten", "3 uur en 25 minuten", "2 uur en 25 minuten", "3 uur en 35 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_duration_calculation",
      "variantIndex": 3,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.76,
      "stimulusAids": [],
      "supportAids": [],
      "feedback": {
        "explanationText": "Strategie: reken in stappen. Stap 1: Van 09:45 naar 10:00 = 15 minuten. Stap 2: Van 10:00 naar 12:00 = 2 uur. Stap 3: Van 12:00 naar 12:20 = 20 minuten. Stap 4: Tel alles op: 2 uur + 15 + 20 = 2 uur en 35 minuten.",
        "distractorExplanations": {
          "0": "Goed! 09:45 → 10:00 (15 min) → 12:00 (2 uur) → 12:20 (20 min) = 2 uur en 35 minuten.",
          "1": "3 uur en 25 minuten klopt niet. Je hebt waarschijnlijk 12 − 9 = 3 uur en 20 − 45 = −25 minuten berekend, maar dat gaat fout bij negatieve minuten. Gebruik de stappenmethode: 09:45 → 10:00 (15 min) → 12:20 (2 uur 20 min) = 2 uur 35 min.",
          "2": "2 uur en 25 minuten klopt bijna, maar je bent 10 minuten kwijt. Controleer je berekening: 15 minuten (naar 10:00) + 2 uur (naar 12:00) + 20 minuten (naar 12:20) = 2 uur en 35 minuten, niet 25.",
          "3": "3 uur en 35 minuten klopt niet. Je hebt waarschijnlijk 12 − 9 = 3 uur genomen, maar dat klopt niet want je vertrekt om 09:45, niet om 09:00. Gebruik de stappenmethode voor nauwkeurigheid."
        }
      }
    },
    {
      "id": "TGL-TIJD-SAMENGESTELD-004",
      "familyId": "TGL-TIJD-SAMENGESTELD",
      "module": "TijdGeld",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "tijdrekenen",
      "subSkill": "tijd_samengesteld",
      "questionType": "multiple_choice",
      "question": "Lisa werkt van 08:15 tot 12:30 en van 13:15 tot 17:00. Hoeveel uur en minuten werkt ze in totaal?",
      "context": null,
      "options": ["8 uur", "8 uur en 30 minuten", "7 uur en 30 minuten", "9 uur"],
      "correctAnswer": 0,
      "conceptId": "time_total_work_hours",
      "variantIndex": 4,
      "citoDifficulty": 0.65,
      "citoDiscrimination": 0.80,
      "stimulusAids": [],
      "supportAids": [],
      "feedback": {
        "explanationText": "Stap 1: Bereken de ochtendshift. Van 08:15 tot 12:30: 12:30 − 08:15 = 4 uur en 15 minuten. Stap 2: Bereken de middagshift. Van 13:15 tot 17:00: 17:00 − 13:15 = 3 uur en 45 minuten. Stap 3: Tel de twee shifts op. 4 uur 15 min + 3 uur 45 min = 7 uur 60 min = 8 uur precies.",
        "distractorExplanations": {
          "0": "Goed! Ochtend: 4 uur 15 min + Middag: 3 uur 45 min = 7 uur 60 min = 8 uur.",
          "1": "8 uur en 30 minuten klopt niet. Je hebt waarschijnlijk een rekenfout gemaakt bij de minuten. Ochtend: 12:30 − 08:15 = 4 uur 15 min. Middag: 17:00 − 13:15 = 3 uur 45 min. Samen: 4u15 + 3u45 = 7u60 = 8u00, niet 8u30.",
          "2": "7 uur en 30 minuten klopt niet. Je bent de minuten vergeten om te zetten: 4u15 + 3u45 = 7u60 minuten. Maar 60 minuten = 1 uur, dus 7u60 = 8u00, niet 7u30.",
          "3": "9 uur klopt niet. Je hebt waarschijnlijk de pauze (van 12:30 tot 13:15 = 45 minuten) meegeteld. Maar de pauze telt niet mee als werktijd. Bereken alleen de twee shifts: 4u15 + 3u45 = 8u00."
        }
      }
    }
  ]
}